import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "https://capizflow.duckdns.org";

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("capizflow_session");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const auth = {
  login: (username, password) =>
    api.post("/admin/login", `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      maxRedirects: 0,
      validateStatus: (s) => s < 400,
    }),
  logout: () => api.get("/admin/logout"),
  changePassword: (data) => api.post("/admin/change-password", data).then((r) => r.data),
};

export const dashboard = {
  getStats: () => api.get("/admin/api/stats").then((r) => r.data),
};

export const ordersApi = {
  getOrders: (page = 1, size = 10) =>
    api.get(`/admin/api/orders?page=${page}&size=${size}`).then((r) => r.data),
  getOrder: (id) => api.get(`/admin/order/${id}`).then((r) => r.data),
  updateOrder: (id, data) => api.post(`/admin/order/${id}`, data).then((r) => r.data),
  resend: (id) => api.post(`/admin/resend/${id}`).then((r) => r.data),
  resendTracking: (id) => api.post(`/admin/resend-tracking/${id}`).then((r) => r.data),
};

export const chat = {
  getConversations: () => api.get("/admin/chat/api/conversations").then((r) => r.data),
  getMessages: (phone) => api.get(`/admin/chat/api/messages/${phone}`).then((r) => r.data),
  getNewMessages: (phone, afterId) =>
    api.get(`/admin/chat/api/messages/${phone}/new?after=${afterId}`).then((r) => r.data),
  sendMessage: (phone, message) =>
    api.post("/admin/chat/api/send", { phone, message }).then((r) => r.data),
  sendMedia: (phone, file, caption) => {
    const form = new FormData();
    form.append("phone", phone);
    form.append("file", file);
    form.append("caption", caption || "");
    return api.post("/admin/chat/api/send-media", form).then((r) => r.data);
  },
  deleteConversation: (phone) =>
    api.post(`/admin/chat/api/delete/${phone}`).then((r) => r.data),
  sendTemplate: (phone, customerName, message) =>
    api.post("/admin/chat/api/send-template", { phone, customerName, message }).then((r) => r.data),
  sendTemplateConfirmation: (phone, customerName, orderNumber, orderTotal, items) =>
    api.post("/admin/chat/api/send-template/confirmation", { phone, customerName, orderNumber, orderTotal, items }).then((r) => r.data),
  sendTemplateTracking: (phone, customerName, orderNumber) =>
    api.post("/admin/chat/api/send-template/tracking", { phone, customerName, orderNumber }).then((r) => r.data),
};

export const messageConfigs = {
  getAll: () => api.get("/admin/api/message-configs").then((r) => r.data),
  update: (key, body) => api.put(`/admin/api/message-configs/${key}`, { body }).then((r) => r.data),
};

export const test = {
  sendTextMessage: (phone, message) =>
    api.post("/admin/test/text-message", { phone, message }).then((r) => r.data),
  sendOrderConfirmation: (data) =>
    api.post("/admin/test/order-confirmation", data).then((r) => r.data),
};

export { API_BASE };
export default api;
